module.exports = __webpack_public_path__ + "img/datum.4d57166a.jpg";